import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isDefined } from 'common';

import { UiBlockType, isBlockType, isSpecialBlockType } from '../../types';

interface UseBlockTypeMetadataProps {
  uiBlockType: UiBlockType | undefined;
}

export function useBlockTypeMetadata(props: UseBlockTypeMetadataProps) {
  const { uiBlockType } = props;
  const blockTypeMetadataResults = useQuery({
    ...getQueryProps(
      api.client.FlowBlockTypeMetadata,
      'findOneByBlockType',
      isBlockType(uiBlockType) || isSpecialBlockType(uiBlockType)
        ? uiBlockType
        : UiBlockType.Unknown
    ),
    enabled: isDefined(uiBlockType),
  });
  return blockTypeMetadataResults;
}
